let baseURL = process.env.VUE_APP_DEFAULT_API_URL;
let pusherKey = '9db4ecb89daebe1a42a0';

if (process.env.NODE_ENV === 'production') {
  if (window.location.origin === 'https://platform-stage.roadcube.app') {
    baseURL = process.env.VUE_APP_API_URL_FOR_APP;
  } else if (window.location.origin === 'https://platform.roadcube.io') {
    baseURL = process.env.VUE_APP_API_URL_FOR_IO;
    pusherKey = '5f85ddb362f7cb4e52d8';
  } else if (window.location.origin === 'https://platform-feature.roadcube.app') {
    baseURL = process.env.VUE_APP_API_URL_FOR_FEATURE;
  }
}

export { baseURL, pusherKey };
